import React from "react";
import BondDocumentUploadBase from "../../shared/components/BondDocumentUploadBase";
import { GUARDIANSHIP_DOCUMENT_UPLOAD_SECTIONS } from "../../shared/documentUploadConfig";

const DocumentUpload = (props) => (
  <BondDocumentUploadBase
    {...props}
    sections={GUARDIANSHIP_DOCUMENT_UPLOAD_SECTIONS}
    useFormHelperScroll
  />
);

export default DocumentUpload;
